import { Flex, ModalCloseButton, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

export const PasswordChangeSuccess = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Flex alignItems="flex-start" h="250px" justifyContent="center" position="relative" w="300px">
      <Text fontSize="22px" textAlign="center">
        {t('ACCOUNT.SETTINGS.MODIFY_PASSWORD.PASSWORD_CHANGED_SUCCESS')}
      </Text>
      <ModalCloseButton
        _hover={{ bgColor: 'brand.red.light' }}
        backgroundColor="brand.red.light"
        borderRadius="0"
        color="white"
        height="50px"
        left="50%"
        position="absolute"
        top="50%"
        transform="translate(-50%, 100%)"
        w="300px"
      >
        <Text fontSize="18px" fontWeight="bold" textTransform="uppercase">
          {t('ACCOUNT.SETTINGS.MODIFY_PASSWORD.CTA_BACK_TO_SETTINGS')}
        </Text>
      </ModalCloseButton>
    </Flex>
  );
};
